module.exports = __webpack_public_path__ + "assets/img/translation-1.bda6715c.svg";